export default class ProductTestingState {
  constructor() {
    // GET Countries List
    this.countriesList = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Job List
    this.jobList = {
      loading: false,
      data: [],
      total: 0,
      error: null,
    };

    // GET Job Detail
    this.jobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Quote List (by jobId)
    this.quoteListJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Quote Detail
    this.quoteDetailJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Report List (by jobId)
    this.reportListJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Report Detail
    this.reportDetailJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Failure Record List (by jobId)
    this.failureRecordListJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Failure Record Detail
    this.failureRecordDetailJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Attachment List (by jobId)
    this.attachmentsJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Invoice (by invoiceId)
    this.invoiceJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Invoice List (by jobId)
    this.invoicesJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Log List (by jobId)
    this.logListJobDetail = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Tag List (by jobId)
    this.tagListJobDetail = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Product List
    this.productList = {
      loading: false,
      data: [],
      total: 0,
      error: null,
    };

    // GET Supplier List
    this.supplierList = {
      loading: false,
      data: [],
      total: 0,
      error: null,
    };

    // GET Tag List
    this.tagList = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Lab List
    this.labList = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Lab Optional List
    this.labOptionalList = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Report Lab List
    this.reportLabList = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Report Citation List
    this.reportCitationList = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Report Test Item List
    this.reportTestItemList = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Service Provider
    this.serviceProvider = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Analytics Data
    this.analyticsData = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Quote Test Item List
    this.quoteTestItemList = {
      loading: false,
      data: [],
      error: null,
    };

    // CREATE
    this.createJob = {
      loading: false,
      data: {},
      error: null,
    };

    this.createQuote = {
      loading: false,
      data: {},
      error: null,
    };

    this.createReport = {
      loading: false,
      data: {},
      error: null,
    };

    this.createFailureRecord = {
      loading: false,
      data: {},
      error: null,
    };

    // DUPLICATE
    this.duplicateJob = {
      loading: false,
      data: {},
      error: null,
    };

    // LINKAGE
    this.updateLinkage = {
      loading: false,
      data: {},
      error: null,
    };

    // UPDATE
    this.updateQuote = {
      loading: false,
      data: {},
      error: null,
    };

    this.updateReport = {
      loading: false,
      data: {},
      error: null,
    };

    this.updateFailureRecord = {
      loading: false,
      data: {},
      error: null,
    };

    // DELETE
    this.deleteReport = {
      loading: false,
      data: {},
      error: null,
    };

    this.deleteFailureRecord = {
      loading: false,
      data: {},
      error: null,
    };

    // DOWNLOAD
    this.quoteDocumentsDownloadedJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    this.reportDownloadedListJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    this.attachmentDownloadedListJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    this.invoiceDownloadedListJobDetail = {
      loading: false,
      data: {},
      error: null,
    };

    // SHARE REPORT LIST
    this.shareReportList = {
      loading: false,
      data: [],
      error: null,
    };
  }
}
